// Turning what a visitor picks or drops into { file, path } entries, where `path`
// is the file's place inside a folder ("Photos/2026/a.jpg") or '' for a plain file.
// The server keeps that structure for the recipient's zip; it is never a disk path.

const readEntry = (entry, prefix = '') => new Promise((resolve) => {
  if (entry.isFile) {
    entry.file((file) => resolve([{ file, path: prefix ? `${prefix}${file.name}` : '' }]), () => resolve([]));
  } else if (entry.isDirectory) {
    const reader = entry.createReader();
    const found = [];
    // readEntries returns results in batches until it returns an empty one.
    const readBatch = () => reader.readEntries(async (batch) => {
      if (!batch.length) {
        const nested = await Promise.all(found.map((e) => readEntry(e, `${prefix}${entry.name}/`)));
        resolve(nested.flat());
        return;
      }
      found.push(...batch);
      readBatch();
    }, () => resolve([]));
    readBatch();
  } else {
    resolve([]);
  }
});

/** Entries from a drop event, descending into any dropped folders. */
export const entriesFromDrop = async (dataTransfer) => {
  // The items must be read synchronously, before the first await.
  const roots = [...(dataTransfer.items || [])]
    .filter((i) => i.kind === 'file')
    .map((i) => (i.webkitGetAsEntry ? i.webkitGetAsEntry() : null));
  if (roots.length && roots.every(Boolean)) {
    return (await Promise.all(roots.map((e) => readEntry(e)))).flat();
  }
  return [...dataTransfer.files].map((file) => ({ file, path: '' }));
};

/** Entries from an <input type="file"> (webkitRelativePath is set for folder picks). */
export const entriesFromInput = (fileList) =>
  [...fileList].map((file) => ({ file, path: file.webkitRelativePath || '' }));
